import { render, staticRenderFns } from "./StudentExemptionFromPhysicalEducation.vue?vue&type=template&id=5b883f6d&"
import script from "./StudentExemptionFromPhysicalEducation.vue?vue&type=script&lang=js&"
export * from "./StudentExemptionFromPhysicalEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports